/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { setWallCloseStateWrap } from '../../../../../../../action';
import { const_var, params } from '../../../../../../../redux/reducers/reducer';

import { CSG } from '../../../../../../../assets/libs/csg-lib';
import { delModel, extrudeSettings, jTrimModel, textureAnisotropy, wainscotTrimModel } from '../../../../../../../utils/Functions';
import { MaterialTrim, MaterialWainScotTrim, MaterialWainScotTrimNew } from '../../../../../CustomMaterial';
import { useThree } from '@react-three/fiber';

const TrimModel = () => {
    const dispatch = useDispatch();
    const { gl } = useThree();

     

    const cBBackWallCloseState = useSelector((state) => state.reducer.backWallCloseState)

    const [frontWallCloseSize, setFrontWallCloseSize] = useState(0);
    const [backWallCloseSize, setBackWallCloseSize] = useState(0);
    const [rightWallCloseSize, setRightWallCloseSize] = useState(0);
    const [leftWallCloseSize, setLeftWallCloseSize] = useState(0);

    const wallThickness = 0.005;
    const Temp_B_p_w = params.leanB_p_w - 0.3;

    const frontJTrimState = params.p_j_t_end && params.p_b_c_b_b_f !== "Open" && params.p_b_c_b_b_f !== "Close";
    const backJTrimState = params.p_j_t_end && params.p_b_c_b_b_b !== "Open" && params.p_b_c_b_b_b !== "Close";
    const rightJTrimState = params.p_j_t && params.p_b_c_b_b_r !== "Open" && params.p_b_c_b_b_r !== "Close" && params.p_b_c_b_b_r !== "Half Dutch End" && params.p_b_c_b_b_r !== "Half End";
    const leftJTrimState = params.p_j_t && params.p_b_c_b_b_l !== "Open" && params.p_b_c_b_b_l !== "Close" && params.p_b_c_b_b_l !== "Half Dutch End" && params.p_b_c_b_b_l !== "Half End";
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined])

    const offset = useMemo(() => {
        if (params.backLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back)) {
            return 0;
        } else if (params.backLeanStoragePosition === 0) {
            return 0.8;
        }
        else {
            return 0.5;
        }
    }, [params.leanB_p_d, legDistance, params.backLeanStoragePosition, params.add_storage_back]);
    

    // const dutchDelModelFront = useMemo(() => {
    //     const freeSpace = 1;
    //     const trimWidth = 0.2;
    //     const offset = 0.05 * Math.pow(2, 1 / 2)
    //     let cornerFreeSpaceW = (params.leanB_p_d - freeSpace) / 6;
    //     let cornerFreeSpaceH = (params.leanB_p_h - freeSpace) / 6
    //     if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

    //     if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
    //     if (params.add_back_lean && (params.p_b_c_b_b_f === "Half Dutch End" || params.p_b_c_b_b_f === "Half End")) {
    //         const model = new THREE.Shape();
    //         model.moveTo(-(params.leanB_p_d / 2 - freeSpace), 0);

    //         if (params.p_b_c_b_b_f === "Half Dutch End") {
    //             model.lineTo(-(params.leanB_p_d / 2 - freeSpace), params.leanB_p_h - freeSpace - cornerFreeSpaceH);
    //             model.lineTo(-(params.leanB_p_d / 2 - freeSpace - cornerFreeSpaceW), params.leanB_p_h - freeSpace);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace - cornerFreeSpaceW), params.leanB_p_h - freeSpace);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace), params.leanB_p_h - freeSpace - cornerFreeSpaceH);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace), 0);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace - trimWidth), 0);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace - trimWidth), params.leanB_p_h - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace - cornerFreeSpaceW - offset), params.leanB_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.leanB_p_d / 2 - freeSpace - cornerFreeSpaceW - offset), params.leanB_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.leanB_p_d / 2 - freeSpace - trimWidth), params.leanB_p_h - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
    //         } else {
    //             model.lineTo(-(params.leanB_p_d / 2 - freeSpace), params.leanB_p_h - freeSpace);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace), params.leanB_p_h - freeSpace);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace), 0);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace - trimWidth), 0);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace - trimWidth), params.leanB_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.leanB_p_d / 2 - freeSpace - trimWidth), params.leanB_p_h - freeSpace - trimWidth);
    //         }
    //         model.lineTo(-(params.leanB_p_d / 2 - freeSpace - trimWidth), 0);
    //         model.closePath()

    //         return model;
    //     } else {
    //         return []
    //     }
    // }, [params.add_back_lean, params.leanB_p_d, params.leanB_p_h, params.p_b_c_b_b_f])

    // const dutchDelModelBack = useMemo(() => {
    //     const freeSpace = 1;
    //     const trimWidth = 0.2;
    //     const offset = 0.05 * Math.pow(2, 1 / 2)
    //     let cornerFreeSpaceW = (params.leanB_p_d - freeSpace) / 6;
    //     let cornerFreeSpaceH = (params.leanB_p_h - freeSpace) / 6
    //     if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

    //     if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
    //     if (params.add_back_lean && (params.p_b_c_b_b_b === "Half Dutch End" || params.p_b_c_b_b_b === "Half End")) {
    //         const model = new THREE.Shape();
    //         model.moveTo(-(params.leanB_p_d / 2 - freeSpace), 0);

    //         if (params.p_b_c_b_b_b === "Half Dutch End") {
    //             model.lineTo(-(params.leanB_p_d / 2 - freeSpace), params.leanB_p_h - freeSpace - cornerFreeSpaceH);
    //             model.lineTo(-(params.leanB_p_d / 2 - freeSpace - cornerFreeSpaceW), params.leanB_p_h - freeSpace);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace - cornerFreeSpaceW), params.leanB_p_h - freeSpace);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace), params.leanB_p_h - freeSpace - cornerFreeSpaceH);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace), 0);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace - trimWidth), 0);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace - trimWidth), params.leanB_p_h - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace - cornerFreeSpaceW - offset), params.leanB_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.leanB_p_d / 2 - freeSpace - cornerFreeSpaceW - offset), params.leanB_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.leanB_p_d / 2 - freeSpace - trimWidth), params.leanB_p_h - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
    //         } else {
    //             model.lineTo(-(params.leanB_p_d / 2 - freeSpace), params.leanB_p_h - freeSpace);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace), params.leanB_p_h - freeSpace);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace), 0);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace - trimWidth), 0);
    //             model.lineTo((params.leanB_p_d / 2 - freeSpace - trimWidth), params.leanB_p_h - freeSpace - trimWidth);
    //             model.lineTo(-(params.leanB_p_d / 2 - freeSpace - trimWidth), params.leanB_p_h - freeSpace - trimWidth);
    //         }
    //         model.lineTo(-(params.leanB_p_d / 2 - freeSpace - trimWidth), 0);
    //         model.closePath()

    //         return model;
    //     } else {
    //         return []
    //     }
    // }, [params.add_back_lean, params.leanB_p_d, params.leanB_p_h, params.p_b_c_b_b_b])
    
    const frontLeftVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_b_f === "Open" || params.p_b_c_b_b_f === "Gable")) {
            model.moveTo(Temp_B_p_w / 2 + 0, frontWallCloseSize);
            model.lineTo(Temp_B_p_w / 2 + 0, params.leanB_p_h - (params.b_l_t_r_pB / 12 * 0.1));
            model.lineTo(Temp_B_p_w / 2 + 0.23, params.leanB_p_h - (params.b_l_t_r_pB / 12 * 0.1));
            model.lineTo(Temp_B_p_w / 2 + 0.23, frontWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanB_p_h, Temp_B_p_w, frontWallCloseSize, params.p_b_c_b_b_f, params.b_l_t_r_pB])
    
    const frontRightVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_b_f === "Open" || params.p_b_c_b_b_f === "Gable")) {
            model.moveTo(-(Temp_B_p_w / 2 + 0.235), frontWallCloseSize);
            model.lineTo(-(Temp_B_p_w / 2 + 0.235), params.leanB_p_h - (params.b_l_t_r_pB / 12 * 0.1));
            model.lineTo(-(Temp_B_p_w / 2 + 0), params.leanB_p_h - (params.b_l_t_r_pB / 12 * 0.1));
            model.lineTo(-(Temp_B_p_w / 2 + 0), frontWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanB_p_h, Temp_B_p_w, frontWallCloseSize, params.p_b_c_b_b_f, params.b_l_t_r_pB])
    
    const rightWallLeftVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_b_r === "Open" || params.p_b_c_b_b_r === "Gable")) {
            model.moveTo((Temp_B_p_w / 2 ), params.leanB_p_h);
            model.lineTo((Temp_B_p_w / 2 ), rightWallCloseSize);
            model.lineTo((Temp_B_p_w / 2 + 0.235), rightWallCloseSize);
            model.lineTo((Temp_B_p_w / 2 + 0.235), params.leanB_p_h);
            model.closePath();
        }

        return model;
    }, [rightWallCloseSize, params.p_b_c_b_b_r, params.leanB_p_h, Temp_B_p_w, params.leanB_p_d, params.p_b_c_b_b_f])
    
    const leftWallRightVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_b_l === "Open" || params.p_b_c_b_b_l === "Gable")) {
            model.moveTo(-(Temp_B_p_w / 2), params.leanB_p_h);
            model.lineTo(-(Temp_B_p_w / 2), leftWallCloseSize);
            model.lineTo(-(Temp_B_p_w / 2 + 0.235), leftWallCloseSize);
            model.lineTo(-(Temp_B_p_w / 2 + 0.235), params.leanB_p_h);
            model.closePath();
        }

        return model;
    }, [leftWallCloseSize, params.p_b_c_b_b_l, params.leanB_p_h, Temp_B_p_w, params.leanB_p_d, params.p_b_c_b_b_f])

    const backLeftVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_b_b === "Open" || params.p_b_c_b_b_b === "Gable")) {
            model.moveTo(-(Temp_B_p_w / 2 + 0.235), backWallCloseSize);
            model.lineTo(-(Temp_B_p_w / 2 + 0.235), params.leanB_p_h - (params.b_l_t_r_pB / 12 * 0.1));
            model.lineTo(-(Temp_B_p_w / 2 + 0), params.leanB_p_h - (params.b_l_t_r_pB / 12 * 0.1));
            model.lineTo(-(Temp_B_p_w / 2 + 0), backWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanB_p_h, Temp_B_p_w, backWallCloseSize, params.p_b_c_b_b_b, params.b_l_t_r_pB])

    const backRightVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        if (!(params.p_b_c_b_b_b === "Open" || params.p_b_c_b_b_b === "Gable")) {
            model.moveTo(Temp_B_p_w / 2 + 0, backWallCloseSize);
            model.lineTo(Temp_B_p_w / 2 + 0, params.leanB_p_h - (params.b_l_t_r_pB / 12 * 0.1));
            model.lineTo(Temp_B_p_w / 2 + 0.23, params.leanB_p_h - (params.b_l_t_r_pB / 12 * 0.1));
            model.lineTo(Temp_B_p_w / 2 + 0.23, backWallCloseSize);
            model.closePath();
        }

        return model;
    }, [params.leanB_p_h, Temp_B_p_w, backWallCloseSize, params.p_b_c_b_b_b, params.b_l_t_r_pB])

    const frontWallHrTrimObj = useMemo(() => {
        let main;
        let wainscot;
        
        // j trim
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(Temp_B_p_w + 0.2)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanFront', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
            
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set((Temp_B_p_w / 2 + 0.15), frontWallCloseSize + 0.1, 0.06)
        meshJTrimModel_Temp.rotation.y = -Math.PI/2
        meshJTrimModel_Temp.updateMatrixWorld()
    
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.leanB_p_pos, 0, -0.5);
        meshDelModel_Temp.updateMatrixWorld()
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        
        const JTrimModel_CSG_Temp = meshJTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(JTrimModel_CSG_Temp,new THREE.Matrix4())

        main = CSGJTrimModel.geometry

        // wainscot trim
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(Temp_B_p_w + 0.02)), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set((Temp_B_p_w / 2 + 0.02), 3, 0.06)
        meshWainscotTrimModel_Temp.rotation.y = -Math.PI/2
        meshWainscotTrimModel_Temp.updateMatrixWorld()

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimModel_CSG,new THREE.Matrix4())

        wainscot = CSGWainscotTrimModel.geometry

        return {main, wainscot}
    }, [Temp_B_p_w, frontWallCloseSize, params.leanB_p_pos, params.p_b_c_b_b_l, params.add_storage_check_back, params.add_storage_back, params.leanB_p_h, const_var.newDoorsArray])

    const backWallHrTrimObj = useMemo(() => {
        let main;
        let wainscot;
        
        // j trim
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(Temp_B_p_w + 0.2)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanBack', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
            
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set(-(Temp_B_p_w / 2 + 0.15), backWallCloseSize + 0.1, -params.leanB_p_d + 0.27);
        meshJTrimModel_Temp.rotation.y = Math.PI/2;
        meshJTrimModel_Temp.updateMatrixWorld();
    
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(params.leanB_p_pos, 0, 0.5 - params.leanB_p_d);
        meshDelModel_Temp.rotation.y = Math.PI;
        meshDelModel_Temp.updateMatrixWorld()
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        
        const JTrimModel_CSG_Temp = meshJTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(JTrimModel_CSG_Temp,new THREE.Matrix4())

        main = CSGJTrimModel.geometry

        // wainscot trim
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(Temp_B_p_w + 0.3)), new THREE.MeshStandardMaterial({color: 'red'}))

        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.position.set(-(Temp_B_p_w / 2 + 0.15), 3, -params.leanB_p_d + 0.27);
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/2;
        meshWainscotTrimModel_Temp.updateMatrixWorld();

        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);

        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotTrimModel = CSG.toMesh(WainscotTrimModel_CSG,new THREE.Matrix4())

        wainscot = CSGWainscotTrimModel.geometry

        return {main, wainscot}
    }, [Temp_B_p_w, backWallCloseSize, params.leanB_p_pos, params.leanB_p_d, params.p_b_c_b_b_l, params.add_storage_check_back, params.add_storage_back, params.leanB_p_h, const_var.newDoorsArray])
    
    const leftWallHrTrimObj = useMemo(() => {
        let main;
        let wainscot;
        
        const storageDelModelSizeOffset = params.backLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back) ? 0 : 0.35;
        
        const storageRightWallModel = new THREE.Shape();
        storageRightWallModel.moveTo(-(params.p_d / 2 - 0.2), params.leanB_p_h);                          
        storageRightWallModel.lineTo(-(params.p_d / 2 - storageDelModelSizeOffset + parseInt(params.add_storage_back) + offset), params.leanB_p_h);        
        storageRightWallModel.lineTo(-(params.p_d / 2 - storageDelModelSizeOffset + parseInt(params.add_storage_back) + offset), 0);  
        storageRightWallModel.lineTo(-(params.p_d / 2 - 0.2), 0);                    
        storageRightWallModel.closePath();

        // j trim
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanB_p_d - 0.1)), new THREE.MeshStandardMaterial({color: 'red'}))
        const storageRightWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageRightWallModel, extrudeSettings(1)));
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanLeft', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
    
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set(-(Temp_B_p_w / 2 + 0.1525), leftWallCloseSize + 0.1, 0.1)
        meshJTrimModel_Temp.rotation.y = Math.PI
        meshJTrimModel_Temp.updateMatrixWorld()

        let storageRightWallDelModel_Temp = storageRightWallDelModel.clone();
        storageRightWallDelModel_Temp.rotateY(Math.PI / 2);
        storageRightWallDelModel_Temp.position.set(-Temp_B_p_w / 2 - 0.5, 0, -(params.p_d / 2 + params.leanB_p_d - params.backLeanStoragePosition - 0.15));
        storageRightWallDelModel_Temp.updateMatrixWorld();

        let meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set( -params.leanB_p_w / 2 + 0.5, 0, -params.leanB_p_d - params.p_d / 2);
        meshDelModel_Temp.rotation.y = -Math.PI / 2;
        meshDelModel_Temp.updateMatrixWorld();
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const storageRightWallDelModel_CSG = CSG.fromMesh(storageRightWallDelModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);

        let storageJTrimDelModel;
        if(params.add_storage_check_back){
            storageJTrimDelModel = meshJTrimModel_CSG.subtract(storageRightWallDelModel_CSG);
        } else {
            storageJTrimDelModel = meshJTrimModel_CSG;
        }
        const JTrimDelModel_CSG = storageJTrimDelModel.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(JTrimDelModel_CSG,new THREE.Matrix4())
        main = CSGJTrimModel.geometry
        
        // wainscot trim
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanB_p_d - 0.1)))
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set(-(Temp_B_p_w / 2 + 0.155), 3, 0.1)
        meshWainscotModel_Temp.rotation.y = Math.PI
        meshWainscotModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);

        let storageWainscotTrimDelModel;
        if(params.add_storage_check_back){
            storageWainscotTrimDelModel = meshWainscotModel_CSG.subtract(storageRightWallDelModel_CSG);
        } else {
            storageWainscotTrimDelModel = meshWainscotModel_CSG;
        }

        const wainscotModel_CSG = storageWainscotTrimDelModel.subtract(meshDelModel_CSG);

        const CSGWainscotModel = CSG.toMesh(wainscotModel_CSG, new THREE.Matrix4())
        wainscot = CSGWainscotModel.geometry

        return {main, wainscot}
    }, [params.leanB_p_d, Temp_B_p_w, params.p_w, leftWallCloseSize, const_var.newDoorsArray, offset, params.backLeanStoragePosition, params.leanB_p_pos, params.add_storage_check_back, params.add_storage_back])

    const rightWallHrTrimObj = useMemo(() => {
        let main;
        let wainscot;
        
        const storageDelModelSizeOffset = params.backLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back) ? 0 : 0.35;
        
        const storageLeftWallModel = new THREE.Shape();
        storageLeftWallModel.moveTo(-(params.p_d / 2 - 0.2), params.leanB_p_h);                         
        storageLeftWallModel.lineTo(-(params.p_d / 2 - storageDelModelSizeOffset + parseInt(params.add_storage_back) + offset), params.leanB_p_h);      
        storageLeftWallModel.lineTo(-(params.p_d / 2 - storageDelModelSizeOffset + parseInt(params.add_storage_back) + offset), 0); 
        storageLeftWallModel.lineTo(-(params.p_d / 2 - 0.2), 0);                    
        storageLeftWallModel.closePath();

        // j trim
        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.leanB_p_d - 0.1)), new THREE.MeshStandardMaterial({color: 'red'}))
        const storageLeftWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageLeftWallModel, extrudeSettings(1)))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanRight', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))

        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.position.set((Temp_B_p_w / 2 + 0.1525), rightWallCloseSize + 0.1, -params.leanB_p_d + 0.2)
        meshJTrimModel_Temp.updateMatrixWorld();

        let storageLeftWallDelModel_Temp = storageLeftWallDelModel.clone();
        storageLeftWallDelModel_Temp.rotateY(Math.PI / 2);
        storageLeftWallDelModel_Temp.position.set((Temp_B_p_w / 2) - 0.5, 0, -(params.p_d / 2 + params.leanB_p_d - params.backLeanStoragePosition - 0.15));
        storageLeftWallDelModel_Temp.updateMatrixWorld();
        
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.rotateY(Math.PI / -2);
        meshDelModel_Temp.position.set((Temp_B_p_w / 2) + 0.5, 0, - params.leanB_p_d - params.p_d / 2);
        meshDelModel_Temp.updateMatrixWorld();
        
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const storageLeftWallDelModel_CSG = CSG.fromMesh(storageLeftWallDelModel_Temp);
    
        let storageJTrimDelModel;
        if(params.add_storage_check_back){
            storageJTrimDelModel = meshJTrimModel_CSG.subtract(storageLeftWallDelModel_CSG);
        } else{
            storageJTrimDelModel = meshJTrimModel_CSG;
        }
        const JTrimModel_CSG = storageJTrimDelModel.subtract(meshDelModel_CSG);
        const CSGJTrimModel = CSG.toMesh(JTrimModel_CSG,new THREE.Matrix4());
        main = CSGJTrimModel.geometry;

        // wainscot trim
        const meshWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanB_p_d - 0.1)))
        let meshWainscotModel_Temp = meshWainscotModel.clone();
        meshWainscotModel_Temp.position.set((Temp_B_p_w / 2 + 0.155), 3, -params.leanB_p_d + 0.2)
        meshWainscotModel_Temp.updateMatrixWorld();
    
        const meshWainscotModel_CSG = CSG.fromMesh(meshWainscotModel_Temp);

        let storageWainscotTrimDelModel;
        if(params.add_storage_check_back){
            storageWainscotTrimDelModel = meshWainscotModel_CSG.subtract(storageLeftWallDelModel_CSG);
        } else{
            storageWainscotTrimDelModel = meshWainscotModel_CSG;
        }
    
        const wainscotModel_CSG = storageWainscotTrimDelModel.subtract(meshDelModel_CSG);
        const CSGWainscotModel = CSG.toMesh(wainscotModel_CSG, new THREE.Matrix4());
        wainscot = CSGWainscotModel.geometry;

        return {main, wainscot}
    }, [params.leanB_p_d, Temp_B_p_w, params.p_w, const_var.newDoorsArray, rightWallCloseSize, offset, params.backLeanStoragePosition, params.leanB_p_pos, params.add_storage_check_back, params.add_storage_back])

    // --- left wall close state    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_b_l === 'Open' || typeof(params.p_b_c_b_b_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanB_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanB_p_h;
            }
        } else if (params.p_b_c_b_b_l === "One_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_l === "Half_Close") {
            tempWallCloseSize = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanB_p_h - 3 * params.p_b_c_b_b_l;
        }

        setLeftWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'FLLeftWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_b_l, params.leanB_p_h, params.p_r_s])

    // --- right wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_b_r === 'Open' || typeof(params.p_b_c_b_b_r) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanB_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanB_p_h;
            }
        } else if (params.p_b_c_b_b_r === "One_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_r === "Half_Close") {
            tempWallCloseSize = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_r === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_r === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanB_p_h - 3 * params.p_b_c_b_b_r;
        }

        setRightWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'FLRightWallCloseState': tempWallCloseSize}))
    }, [params.p_b_c_b_b_r, params.leanB_p_h, params.p_r_s])
    
    // --- front wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.p_b_c_b_b_f === "One_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_f === "Gable") {
            tempWallCloseSize = params.leanB_p_h - 0.2;
        } else if (params.p_b_c_b_b_f === "Half_Close") {
            tempWallCloseSize = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_f === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_f === "Close") {
            tempWallCloseSize = 0;
        } else if (params.p_b_c_b_b_f === "Half Dutch End") {
            tempWallCloseSize = 0;
        } else if (params.p_b_c_b_b_f === "Half End") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = -1;
        }

        setFrontWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_b_f, params.leanB_p_h, params.p_r_s])

    // --- back wall set    
    useMemo(() => {
        let tempWallCloseSize;
        if (params.add_storage_check_back) {
            tempWallCloseSize = 0;
        } else {
            if (params.p_b_c_b_b_b === "One_Fourth_Close") {
                tempWallCloseSize = params.leanB_p_h / 4 * 3;
            } else if (params.p_b_c_b_b_b === "Gable") {
                tempWallCloseSize = params.leanB_p_h - 0.2;
            } else if (params.p_b_c_b_b_b === "Half_Close") {
                tempWallCloseSize = params.leanB_p_h / 2;
            } else if (params.p_b_c_b_b_b === "Three_Fourth_Close") {
                tempWallCloseSize = params.leanB_p_h / 4;
            } else if (params.p_b_c_b_b_b === "Half End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_b_b === "Half Dutch End") {
                tempWallCloseSize = 0;
            } else if (params.p_b_c_b_b_b === "Close") {
                tempWallCloseSize = 0;
            } else {
                tempWallCloseSize = -1;
            }
        }

        setBackWallCloseSize(tempWallCloseSize);
        dispatch(setWallCloseStateWrap({'FLRightWallCloseState': tempWallCloseSize}))
    }, [params.add_storage_check_back, params.p_b_c_b_b_b, params.leanB_p_h, params.p_r_s])

    return (
        <>
            <group position={[0, 0, -(params.p_d / 2 + params.leanB_p_d - 0.05 - wallThickness)]} rotation={[0, Math.PI, 0]}>
                <mesh name="right-wall-left-trim" position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[rightWallLeftVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"gableBackLean"} />
                </mesh>
                <mesh name="left-wall-right-trim" position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[leftWallRightVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"gableBackLean"} />
                </mesh>
                <mesh name="front-wall-left-trim" position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[frontLeftVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"gableBackLean"} />
                </mesh>
                <mesh name="front-wall-right-trim"position={[0, 0, -0.015]}>
                    <extrudeGeometry args={[frontRightVrTrimModel, extrudeSettings(0.16)]} />
                    <MaterialTrim visibleSection={"gableBackLean"} />
                </mesh>

                <group position={[0, 0, - params.leanB_p_d + 0.2]}>
                    {/* {params.leanB_p_pos !== -(params.p_w - params.leanB_p_w) / 2 && <> */}
                        <mesh name="right-wall-right-trim" position={[0, 0, -0.015]}>
                            <extrudeGeometry args={[rightWallLeftVrTrimModel, extrudeSettings(0.16)]} />
                            <MaterialTrim visibleSection={"gableBackLean"} />
                        </mesh>
                        <mesh name="back-wall-left-trim" position={[0, 0, -0.015]}>
                            <extrudeGeometry args={[backLeftVrTrimModel, extrudeSettings(0.16)]} />
                            <MaterialTrim visibleSection={"gableBackLean"} />
                        </mesh>
                    {/* </>} */}
                    {/* {params.leanB_p_pos !== (params.p_w - params.leanB_p_w) / 2 && <> */}
                        <mesh name="left-wall-left-trim" position={[0, 0, -0.015]}>
                            <extrudeGeometry args={[leftWallRightVrTrimModel, extrudeSettings(0.16)]} />
                            <MaterialTrim visibleSection={"gableBackLean"} />
                        </mesh>
                        <mesh name="back-wall-right-trim"position={[0, 0, -0.015]}>
                            <extrudeGeometry args={[backRightVrTrimModel, extrudeSettings(0.16)]} />
                            <MaterialTrim visibleSection={"gableBackLean"} />
                        </mesh>
                    {/* </>} */}
                </group>

                {frontJTrimState &&
                    <mesh name="front-wall-J-trim" geometry={frontWallHrTrimObj.main}>
                        <MaterialTrim visibleSection={"gableBackLean"} />
                    </mesh>
                }
                {backJTrimState &&
                    <mesh name="back-wall-J-trim" geometry={backWallHrTrimObj.main}>
                        <MaterialTrim visibleSection={"gableBackLean"} />
                    </mesh>
                }
                {leftJTrimState &&
                    <mesh name="left-wall-J-trim" geometry={leftWallHrTrimObj.main}>
                        <MaterialTrim visibleSection={"gableBackLean"} />
                    </mesh>
                }
                {rightJTrimState &&
                    <mesh name="right-wall-J-trim" geometry={rightWallHrTrimObj.main}>
                        <MaterialTrim visibleSection={"gableBackLean"} />
                    </mesh>
                }

                {params.p_w_c_n === true && params.p_b_c_b_b_f === "Close" &&
                    <mesh name="G_B_L_F_W_wainscotTrim" geometry={frontWallHrTrimObj.wainscot} >
                        <MaterialWainScotTrimNew visibleSection={"gableBackLean"}  />
                    </mesh>
                }
                {params.p_w_c_n === true && params.p_b_c_b_b_b === "Close" &&  
                    <mesh name="G_B_L_B_W_wainscotTrim" geometry={backWallHrTrimObj.wainscot} >
                        <MaterialWainScotTrimNew visibleSection={"gableBackLean"}  />
                    </mesh>
                }
                {params.p_w_c_n === true && params.p_b_c_b_b_l === "Close" &&
                    <mesh name="G_B_L_L_W_wainscotTrim" geometry={leftWallHrTrimObj.wainscot} >
                        <MaterialWainScotTrimNew visibleSection={"gableBackLean"}  />
                    </mesh>
                }
                {params.p_w_c_n === true && params.p_b_c_b_b_r === "Close" &&
                    <mesh name="G_B_L_R_W_wainscotTrim" geometry={rightWallHrTrimObj.wainscot} >
                        <MaterialWainScotTrimNew visibleSection={"gableBackLean"}  />
                    </mesh>
                }
            </group>

            {/* <mesh position={[ -(params.leanB_p_d / 2 + params.p_w / 2), 0, Temp_B_p_w / 2 + 0.1]} >
                <extrudeGeometry args={[dutchDelModelFront, extrudeSettings(0.15)]}/>
                <MaterialTrim visibleSection={"gableBackLean"} />
            </mesh>
            <mesh position={[ -(params.leanB_p_d / 2 + params.p_w / 2), 0, - (Temp_B_p_w / 2 + 0.25)]} >
                <extrudeGeometry args={[dutchDelModelBack, extrudeSettings(0.15)]}/>
                <MaterialTrim visibleSection={"gableBackLean"} />
            </mesh> */}
        </>
    )
}

export default TrimModel